'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';
import posthog from 'posthog-js';

/**
 * Component to track pageviews in PostHog for Next.js App Router.
 * PostHog's automatic pageview capture only fires on initial page load,
 * so we manually capture pageviews on client-side route changes.
 */
export function PostHogPageView() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Skip the first render - PostHog's capture_pageview handles initial load
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (pathname && typeof window !== 'undefined' && window.posthog) {
      let url = window.origin + pathname;
      if (searchParams?.toString()) {
        url = url + '?' + searchParams.toString();
      }
      posthog.capture('$pageview', {
        $current_url: url,
      });
    }
  }, [pathname, searchParams]);

  return null;
}
